
function promotionPopUpSchema({ flightType, flightCategory, familyFare, routes, typePromotion, creative }) {
  const objTypePromotion = typePromotion === 'promotionImpression' ? 
    {
      promoView: {
        promotions: [{
          creative: creative || 'Inscríbete sin costo a Club Premier',
          id:'SignUpPP',
          name: 'Pop-Up SignUp',
          position: 'MYB',
        }],
      },
    } :
    {
      promoClick: {
        promotions: [{
          creative: creative || 'Inscríbete sin costo a Club Premier',
          id:'SignUpPP',
          name: 'Pop-Up SignUp',
          position: 'MYB',
        }],
      },
    };
  return {
    ecommerce: objTypePromotion,
    event: typePromotion,
    familyFare: familyFare ? familyFare : 'N/A',
    flightCategory: flightCategory ? flightCategory : 'N/A',
    flightType: flightType ? flightType : 'N/A',
    route: routes ? routes : 'N/A',
  };
}

export default promotionPopUpSchema;